module.exports = __webpack_public_path__ + "static/img/failure_logo.11bff220.png";